
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const steps = [
  {
    number: '01',
    title: 'Visita y medición',
    description: 'Nos desplazamos a tu ubicación en Badalona para evaluar el proyecto y tomar medidas exactas.',
  },
  {
    number: '02',
    title: 'Presupuesto detallado',
    description: 'Te enviamos un presupuesto claro y sin sorpresas en menos de 24 horas.',
  },
  {
    number: '03',
    title: 'Planificación',
    description: 'Acordamos fechas y coordinamos todos los detalles para minimizar molestias.',
  },
  {
    number: '04',
    title: 'Ejecución',
    description: 'Realizamos la instalación con profesionalidad, limpieza y respeto por tu espacio.',
  },
  {
    number: '05',
    title: 'Acabados finales',
    description: 'Entregamos la obra lista para pintar con acabados perfectos y limpieza completa.',
  },
];

const ProcessSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="py-24 bg-dark-bg">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="inline-block px-4 py-2 bg-orange-primary/10 border border-orange-primary rounded-full mb-6"
          >
            <span className="text-orange-primary text-sm font-bold">Proceso</span>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-4xl md:text-5xl font-extrabold text-text-primary mb-6"
          >
            Cómo trabajamos
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-text-secondary text-lg max-w-2xl mx-auto"
          >
            Un proceso simple y transparente de principio a fin
          </motion.p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Connecting Line - Desktop */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-orange-primary to-transparent"></div>

          {/* Steps Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-4">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: 0.15 * index }}
                className="flex flex-col items-center text-center"
              >
                {/* Number Circle */}
                <div className="relative mb-6">
                  <div className="w-24 h-24 bg-gradient-to-br from-orange-primary to-orange-secondary rounded-full flex items-center justify-center shadow-glow-orange-lg">
                    <span className="text-white text-2xl font-extrabold">{step.number}</span>
                  </div>
                  {/* Connecting Line - Mobile/Tablet */}
                  {index < steps.length - 1 && (
                    <div className="lg:hidden absolute top-full left-1/2 -translate-x-1/2 w-0.5 h-8 bg-orange-primary/30"></div>
                  )}
                </div>

                {/* Content Card */}
                <div className="bg-dark-card border border-dark-border rounded-xl p-6 w-full h-full">
                  <h3 className="text-lg font-bold text-text-primary mb-3">
                    {step.title}
                  </h3>
                  <p className="text-text-muted text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
